import { ApiError } from '@/api/client';
import { t } from '@/i18n';

/**
 * Человеческий текст ошибки. Для сети, доступа и 5xx у клиента свои слова;
 * остальные сообщения сервер уже присылает на языке пользователя.
 */
export function errorText(error: Error | ApiError): string {
  if (error instanceof ApiError) {
    if (error.statusCode === 0) return error.error === 'TimeoutError' ? t('lib.error.timeout') : t('lib.error.network');
    if (error.statusCode === 401 || error.statusCode === 403) return t('lib.error.forbidden');
    if (error.statusCode >= 500) return t('lib.error.server');
    return error.message;
  }
  return error.message || t('lib.error.unknown');
}
